import React, { Component } from 'react';
import './TravelDiaryListItem.css';

import { AutoTruncateTextLabel } from '../../../../.common/AutoTruncateTextLabel/AutoTruncateTextLabel';
import ApiOviewDocmd from '../../../../../modules/WebApiModules/ApiOviewDocmd'; 

import locate from './.image/locate-2.png';
import del from './.image/delete.png';
import visible from './.image/Visible.png';
import unVisible from './.image/Unvisible.png';

export class TravelDiaryListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEdit: false,
        }
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <div className='TravelDiaryListItem' style={this.props.style}>
                <AutoTruncateTextLabel data={{
                    text: this.props.name,
                    style: { width: 'calc(100% - 50px)' }
                }} />
                {
                    <div>
                        {this.props.isDelete ? <img src={del} width={25} height={25} onClick={() => { this.props.userDelete(this.props.name)}} /> : null}
                        <img src={locate} width={25} height={25} onClick={() => { this.props.goto(this.props.pos, this.props.index); }} />
                        <img src={this.props.show ? visible : unVisible} width={25} height={25} onClick={() => { this.props.setShow(this.props.index) }} />
                    </div>
                }
            </div>
        );
    }

}